<template>
  <div>
    <div class="container container-paddingb mt-3" v-bind:style="width < 1025 ? 'padding-left: 0; padding-right: 0;' : ''">
      <div class="row mt-5">
        <div class="col-md-6">
          <div class="row">
            <div class="col-lg-4 col-4">
              <span v-if="width > 768" class="helper"></span><img class="img-fluid" src="../assets/clients1.png"/>
            </div>
            <div v-bind:class="['col-lg-8 col-8 pl-0']">
              <h1 ref="longer_title" class=" font-weight-bold description roboto-style">How we helped increase the number of adopted children by 67%</h1>
              <p ref="longer_text" class="small-description inter-style medium-grey">Developing a scalable, cost-effective platform based on the strict regulations of the Romanian adoption law wasn’t easy, but we did it.</p>
                <router-link class="font-weight-bold d-inline-block dark-grey button greenbtn smallbtn roboto-style" v-bind:style="width > 1200 ? 'margin-top: 5px' : ''" to="/request-case-study">
                  Request case study
                  <arrow></arrow>
                </router-link>
            </div>
          </div>
        </div>
        <div v-bind:class="['col-md-6', {'mt-5' : width < 768}]">
          <div class="row">
            <div class="col-lg-4 col-4">
              <span v-if="width > 768" class="helper"></span><img class="img-fluid" src="../assets/clients2.png"/>
            </div>
            <div v-bind:class="['col-lg-8 col-8 pl-0']">
              <h1 ref="shorter_title" class=" font-weight-bold description roboto-style">How we helped Coca Cola increase customer loyalty</h1>
              <p ref="shorter_text" class="small-description inter-style medium-grey">Find out how we developed high-return SMS marketing and API contests for global FMCG brands like Coca Cola.</p>
              <router-link class="font-weight-bold d-inline-block dark-grey button greenbtn smallbtn roboto-style" v-bind:style="width > 1200 ? 'margin-top: 5px' : ''" to="/request-case-study">
                Request case study
                <arrow></arrow>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="width >= 768" class="black-container roboto-style row">
      <div class="container">
        <div class="row mt-5 mb-5 roboto-style">
          <div class="col-md-3">
            <div class="row">
              <div class="col-md-4">
                <icn1></icn1>
              </div>
              <div class="col-lg-8 col-md-6 offset-md-2 offset-lg-0 pl-0">
                <p class="m-0 font-weight-bold white boldnr pt-lg-4 pt-2">300+</p>
                <p class="m-0 small-description inter-style light-grey">Successful projects</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 pl-3">
            <div class="row">
              <div class="col-md-4">
                <icn2></icn2>
              </div>
              <div class="col-lg-8 col-md-6 offset-md-2 offset-lg-0 pl-0">
                <p class="m-0 font-weight-bold white boldnr pt-lg-4 pt-2">10+</p>
                <p class="m-0 small-description inter-style light-grey">Years of experience</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 pl-3">
            <div class="row">
              <div class="col-md-4">
                <icn3></icn3>
              </div>
              <div class="col-lg-8 col-md-6 offset-md-2 offset-lg-0 pl-0">
                <p class="m-0 font-weight-bold white boldnr pt-lg-4 pt-2">100%</p>
                <p class="m-0 small-description inter-style light-grey">Client retention</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 pl-3">
            <div class="row">
              <div class="col-md-4">
                <icn4></icn4>
              </div>
              <div class="col-lg-8 col-md-6 offset-md-2 offset-lg-0 pl-0">
                <p class="m-0 font-weight-bold white boldnr pt-lg-4 pt-2">2</p>
                <p class="m-0 small-description inter-style light-grey">Continents available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lightgrey-container row">
      <div v-bind:class="['container container-paddingt', {'pb-5' : width > 1025}]">
        <div class="row">
          <h2 class="col-md-12 dark-grey roboto-style title mt-5">100% Client Retention</h2>
          <p class="col-lg-8 col-md-12 medium-grey inter-style description mt-2 mb-0">Results speak for themselves since we have never lost a client.</p>
          <p class="col-lg-8 col-md-12 medium-grey inter-style description mt-0">And many of them have been coming back to us for years now.</p>
        </div>
        <div class="row inter-style medium-grey mt-5 text-center">
          <div class="col-md-4">
            <div>
              <div class=" bg-white pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
                <div class="row d-flex align-items-center justify-content-center">
                  <img class="col-md-6 col-6 col-sm-4" src="../assets/groupon.png"/>
                </div>
                <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-12 col-md-12 position-absolute">Worldwide platform which eventually became Groupon Scheduler.</p></div>
              </div>
            </div>
          </div>
          <div class="col-md-4" v-bind:style="width<768?'margin-top: 30px;':''">
            <div>
              <div class="bg-white pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
                <div class="row d-flex align-items-center justify-content-center">
                  <img class="col-md-6 col-6 col-sm-4"src=".././assets/vodafone.png"/>
                </div>
                <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-10 col-md-12 position-absolute">British multinational of communications services.</p></div>
              </div>
            </div>
          </div>
          <div class="col-md-4" v-bind:style="width<768?'margin-top: 30px;':''">
            <div>
            <div class=" bg-white pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
              <div class="row d-flex align-items-center justify-content-center">
                <img class="col-md-6 col-6 col-sm-4 mt-3"src=".././assets/gdf-suez.png"/>
              </div>
              <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-10 col-md-12 position-absolute">French multinational utility company.</p></div>
            </div>
            </div>
          </div>
        </div>
        <div class="row inter-style medium-grey text-center" v-bind:style="width >=768 ? 'margin-top: 30px;' : ''">
          <div class="col-md-4" v-bind:style="width<768?'margin-top: 30px;':''">
            <div>
            <div class="bg-white pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
              <div class="row d-flex align-items-center justify-content-center">
                <img class="col-md-6 col-6 col-sm-4" src=".././assets/ferrero.png"/>
              </div>
              <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-10 col-md-12 position-absolute">Italian manufacturer of branded chocolate.</p></div>
            </div>
            </div>
          </div>
        <div class="col-md-4" v-bind:style="width<768?'margin-top: 30px;':''">
          <div>
          <div class=" bg-white pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
              <div class="row d-flex align-items-center justify-content-center">
                <img class="col-md-6 col-6 col-sm-4" src=".././assets/coca-cola.png"/>
              </div>
              <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-10 col-md-12 position-absolute">World-wide famous soft drink manufacturer.</p></div>
            </div>
          </div>
          </div>
        <div class="col-md-4" v-bind:style="width<768?'margin-top: 30px;':''">
          <div>
          <div class="col-md-12 bg-white pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
              <div class="row d-flex align-items-center justify-content-center">
                <img class="col-md-3 col-3 col-sm-3" src=".././assets/orange.png"/>
              </div>
              <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-10 col-md-12 position-absolute">French multinational telecommunications corporation.</p></div>
            </div>
          </div>
          </div>
        </div>
        <div class="row inter-style medium-grey text-center" v-bind:style="width >= 768 ? 'margin-top: 30px;' : ''">
        <div class="col-md-4" v-bind:style="width<768?'margin-top: 30px;':''">
          <div>
          <div class="col-md-12 bg-white  pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
              <div class="row d-flex align-items-center justify-content-center">
                <img class=" col-md-6 col-6 col-sm-4"src=".././assets/carlsberg.png"/>
              </div>
              <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-10 col-md-12 position-absolute">Global brewer.</p></div>
            </div>
          </div>
          </div>
        <div class="col-md-4" v-bind:style="width<768?'margin-top: 30px;':''">
          <div>
          <div class="col-md-12 bg-white pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
              <div class="row d-flex align-items-center justify-content-center">
                <img class="col-md-3 col-3 col-sm-3" src=".././assets/unilever.png"/>
              </div>
              <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-10 col-md-12 position-absolute">Transnational consumer goods company.</p></div>
            </div>
          </div>
          </div>
        <div class="col-md-4" v-bind:style="width<768?'margin-top: 30px;':''">
          <div>
          <div class="col-md-12 bg-white pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
              <div class="row d-flex align-items-center justify-content-center">
                <img class="col-md-6 col-6 col-sm-4 mt-3" src=".././assets/anastasia.png"/>
              </div>
              <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-10 col-md-12 position-absolute">American cosmetics company.</p></div>
            </div>
          </div>
          </div>
        </div>
        <div class="row inter-style medium-grey text-center" v-bind:style="width >= 768 ? 'margin-top: 30px;' : ''">
        <div class="col-md-4" v-bind:style="width<768?'margin-top: 30px;':''">
          <div>
            <div class="col-md-12 bg-white pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
              <div class="row d-flex align-items-center justify-content-center">
                <img class=" col-md-6 col-6 col-sm-4 col-6" src=".././assets/danone.png"/>
              </div>
              <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-10 col-md-12 position-absolute">French multinational food-products corporation.</p></div>
            </div>
          </div>
        </div>
        <div class="col-md-4" v-bind:style="width<768?'margin-top: 30px;':''">
          <div>
          <div class="col-md-12 bg-white pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
              <div class="row d-flex align-items-center justify-content-center">
                <img class="col-md-3 col-3 col-sm-3"src=".././assets/guvernulromaniei.png"/>
              </div>
              <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-10 col-md-12 position-absolute">The public authority of executive power.</p></div>
            </div>
          </div>
          </div>
        <div class="col-md-4" v-bind:style="width<768?'margin-top: 30px;':''">
          <div>
          <div class="col-md-12 bg-white pb-4 position-relative" style="padding-top: 9rem; min-height: 400px;">
              <div class="row d-flex align-items-center justify-content-center">
                <img class="col-md-3 col-3 col-sm-3" src=".././assets/upc.png"/>
              </div>
              <div class="row d-flex align-items-center justify-content-center"> <p style="bottom: 20px" class="text-center offset-lg-0 col-lg-10 col-md-12 position-absolute">A telecommunications company in Romania.</p></div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div class="container container-paddingt container-paddingb">
        <div class="row"><h2 v-bind:class="['col-md-11 dark-grey title roboto-style', {'mt-5' : width > 768}]">Our team has experience<br/> delivering solutions in multiple industries</h2></div>
        <div class="row mt-3"><p class="col-lg-6 col-md-8 description inter-style medium-grey mb-0">Which are based on years of experience in multiple industries and deep understanding of business needs.</p></div>
        <div v-bind:class="['row inter-style dark-grey small-description xs_margint', {'mt-5' : width > 1023}]">
          <div class="col-md-4">
            <p class="mb-0">· Telecommunication</p>
            <p class="mb-0">· Public Sector /Government </p>
            <p class="mb-0">· FMCG</p>
          </div>
          <div class="col-md-4">
            <p class="mb-0">· Health</p>
            <p class="mb-0">· Media & Entertainment</p>
            <p class="mb-0">· Beauty</p>
          </div>
          <div class="col-md-4">
            <p class="mb-0">· Fashion</p>
            <p class="mb-0">· Energy</p>
            <p class="mb-0">· Finance</p>
          </div>
        </div>
      </div>
    </div>
    <testemonials></testemonials>
    <conversation></conversation>
  </div>
</template>

<script>
    import Arrow from './arrow';
    import icn1 from './greenicn1';
    import icn2 from './greenicn2';
    import icn3 from './greenicn3';
    import icn4 from './greenicn4';
    import testemonials from './testemonials';
    import conversation from "./conversation";
    export default {
        components: {
            Arrow: Arrow,
            icn1: icn1,
            icn2: icn2,
            icn3: icn3,
            icn4: icn4,
            testemonials,
            conversation
        },
        data: function () {
            return {
                index: 0,
                width: 0
            }
        },
        methods: {
            resizeEvent() {
                this.windowWidth = window.innerWidth;
                this.$refs.shorter_text.style.height = this.$refs.longer_text.offsetHeight + 'px';
                this.$refs.shorter_title.style.height = this.$refs.longer_title.offsetHeight + 'px';
            }
        },
        computed: {
            windowWidth: {
                get: function () {
                    return this.width;
                },
                set: function (val) {
                    this.width = val;
                }

            }
        },
        mounted() {
            this.$refs.shorter_text.style.height = this.$refs.longer_text.offsetHeight + 'px';
            this.$refs.shorter_title.style.height = this.$refs.longer_title.offsetHeight + 'px';
            this.width = window.innerWidth;
            window.addEventListener('resize', this.resizeEvent);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.resizeEvent);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/clients.vue